<pm-dialog
  dialogTitle="Widget View konfigurieren"
  class="min-w-[80vw] h-[80vh]"
  contentClass="gap-8 space-y-2"
  [primaryCtaButtonConfig]="buttonConfig.submitButton"
  [secondaryCtaButtonConfig]="buttonConfig.cancelButton"
>
  <div
    cdkDropList
    cdkDropListOrientation="mixed"
    class="grid grid-cols-2 w-full gap-4"
    (cdkDropListDropped)="drop($event)"
  >
    @for (widget of widgets; track $index) {
      <div
        cdkDrag
        class="border rounded-md bg-background flex flex-col gap-2 p-4 group relative min-h-96"
        (cdkDragStarted)="this.isDragging = true"
        (cdkDragEnded)="this.isDragging = false"
      >
        <p
          class="w-full border border-primary rounded-lg cursor-pointer bg-slate-50 flex flex-col gap-2 px-4 py-2 text-center justify-center items-center italic text-sm"
          *cdkDragPlaceholder
        >
          Neue Widget-Position
        </p>
        <div *cdkDragPreview>
          <pm-form-field class="block flex-1" label="Widget">
            <pm-form-input-select
              placeholder="Widget auswählen"
              [data]="supportedWidgetOptions"
              [preserveOrder]="true"
              (ngModelChange)="changedWidgetType($event, $index)"
              ngModel
            />
          </pm-form-field>
        </div>
        <div class="flex flex-row gap-4">
          <div class="flex flex-col flex-grow">
            <pm-form-field class="block" label="Name">
              <pm-form-input-text
                [ngModel]="widget.name || ''"
                (ngModelChange)="changedWidgetName($event, $index)"
              />
            </pm-form-field>
            <pm-form-field class="block" label="Widget">
              <pm-form-input-select
                placeholder="Widget auswählen"
                [data]="supportedWidgetOptions"
                [preserveOrder]="true"
                [ngModel]="widget.type || 'PLACEHOLDER'"
                (ngModelChange)="changedWidgetType($event, $index)"
              />
            </pm-form-field>
          </div>
          <div
            class="flex flex-col justify-center cursor-pointer"
            cdkDragHandle
          >
            <pm-icon [icon]="dragIcon" size="md"></pm-icon>
          </div>
        </div>

        <mat-divider />
        <div class="flex flex-col gap-4 w-full">
          <p class="underline">Konfigurationsmöglichkeiten</p>
          @switch (widget.type) {
            @case (WidgetType.SINGLE_FORECASTS) {
              <div class="flex flex-col gap-4">
                <pm-resolution-picker
                  [resolution]="widget.resolution"
                  (resolutionChange)="changeResolution($event, $index)"
                />
                <pm-target-unit-picker
                  [showWarningMessageForNoMultipleTargetUnit]="true"
                  [skipTargetUnitUrlUpdate]="true"
                  [targetUnit]="widget.targetUnit"
                  (targetUnitChange)="changeTargetUnit($event, $index)"
                />

                <!-- filter -->
                <pm-form-field
                  class="block"
                  label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER"
                >
                  <pm-form-input-select
                    [data]="availableFiltersOptions()"
                    [preserveOrder]="true"
                    [ngModel]="widget.filterColumn"
                    (ngModelChange)="
                      changeSingleForecastsFilter(
                        $event,
                        $index,
                        'filterColumn'
                      )
                    "
                  />
                </pm-form-field>

                <!-- filter options -->
                <pm-form-field
                  class="block"
                  label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET"
                >
                  <pm-form-input-select
                    [multiSelect]="true"
                    [allowSearching]="true"
                    [allowUnselect]="true"
                    [data]="
                      getFilterOptionsOfFilterColumnSingleForecast($index)
                    "
                    [preserveOrder]="true"
                    [ngModel]="widget.filterOptions"
                    (ngModelChange)="
                      changeSingleForecastsFilter(
                        $event,
                        $index,
                        'filterOptions'
                      )
                    "
                  />
                </pm-form-field>
              </div>
            }
            @case (WidgetType.PORTFOLIO_TOTALS) {
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />

              <!-- filter -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER"
              >
                <pm-form-input-select
                  [data]="availableFiltersOptionsForPortfolioTotals()"
                  [preserveOrder]="true"
                  [ngModel]="widget.filter"
                  (ngModelChange)="
                    changePortfolioTotalsSettings($event, $index, 'filter')
                  "
                />
              </pm-form-field>

              <!-- year -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_YEAR"
              >
                <pm-form-input-select
                  [data]="possibleYearsOptions()"
                  [preserveOrder]="true"
                  [ngModel]="widget.year"
                  (ngModelChange)="
                    changePortfolioTotalsSettings($event, $index, 'year')
                  "
                />
              </pm-form-field>
            }
            @case (WidgetType.PORTFOLIO_TOTALS_MULTI_YEAR) {
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />

              <!-- filter -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER"
              >
                <pm-form-input-select
                  [data]="availableFiltersOptions()"
                  [preserveOrder]="true"
                  [ngModel]="widget.filter"
                  (ngModelChange)="
                    changePortfolioTotalsMultiYearSettings(
                      $event,
                      $index,
                      'filter'
                    )
                  "
                />
              </pm-form-field>

              <!-- years -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_YEARS"
              >
                <pm-form-input-select
                  [multiSelect]="true"
                  [allowUnselect]="true"
                  [data]="possibleYearsOptions()"
                  [preserveOrder]="true"
                  [ngModel]="widget.years"
                  (ngModelChange)="
                    changePortfolioTotalsMultiYearSettings(
                      $event,
                      $index,
                      'years'
                    )
                  "
                />
              </pm-form-field>
            }
            @case (WidgetType.YEAR_TO_DATE_TREND) {
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />

              <!-- filter -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER"
              >
                <pm-form-input-select
                  [data]="availableFiltersOptions()"
                  [preserveOrder]="true"
                  [ngModel]="widget.filterColumn"
                  (ngModelChange)="
                    changeYearToDateFilter($event, $index, 'filterColumn')
                  "
                />
              </pm-form-field>

              <!-- filter options -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET"
              >
                <pm-form-input-select
                  [multiSelect]="true"
                  [allowUnselect]="true"
                  [data]="getFilterOptionsOfFilterColumnTrendAnalysis($index)"
                  [preserveOrder]="true"
                  [ngModel]="widget.filterOptions"
                  (ngModelChange)="
                    changeYearToDateFilter($event, $index, 'filterOptions')
                  "
                />
              </pm-form-field>
            }
            @case (WidgetType.YEARLY_COMPARISON) {
              <pm-resolution-picker
                [resolution]="widget.resolution"
                (resolutionChange)="changeResolution($event, $index)"
              />
              <pm-target-unit-picker
                [showWarningMessageForNoMultipleTargetUnit]="true"
                [skipTargetUnitUrlUpdate]="true"
                [targetUnit]="widget.targetUnit"
                (targetUnitChange)="changeTargetUnit($event, $index)"
              />
              <!-- filter -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER"
              >
                <pm-form-input-select
                  [data]="yearlyComparisonFilterOptions()"
                  [preserveOrder]="true"
                  [ngModel]="widget.filterColumn"
                  (ngModelChange)="
                    changeYearlyComparisonConfiguration(
                      $event,
                      $index,
                      'filterColumn'
                    )
                  "
                />
              </pm-form-field>
              <!-- filter options -->
              <pm-form-field
                class="block"
                label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET"
              >
                <pm-form-input-select
                  [data]="
                    getFilterOptionsOfFilterColumnYearlyComparison($index)
                  "
                  [preserveOrder]="true"
                  [ngModel]="widget.filterOptions"
                  (ngModelChange)="
                    changeYearlyComparisonConfiguration(
                      $event,
                      $index,
                      'filterOptions'
                    )
                  "
                />
              </pm-form-field>
            }
            @case (WidgetType.PLANNING_ACCURACY) {
              <div class="flex flex-col gap-4">
                <!-- planning period -->
                <pm-form-field
                  class="block"
                  label="RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.PLANNING_PERIOD"
                >
                  <pm-form-input-number
                    placeholder="1"
                    [min]="0"
                    [ngModel]="widget.planningPeriod"
                    (ngModelChange)="setPlanningPeriod($event, $index)"
                  />
                </pm-form-field>

                <pm-resolution-picker
                  [resolution]="widget.resolution"
                  (resolutionChange)="changeResolution($event, $index)"
                />

                <!-- filter group -->
                <pm-form-field
                  class="block"
                  label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER"
                >
                  <pm-form-input-select
                    [data]="availableFiltersOptions()"
                    [preserveOrder]="true"
                    [ngModel]="widget.selectedFilterGroup"
                    (ngModelChange)="
                      changeDefaultFilterSelectionOfPlanningAccuracyWidget(
                        $event,
                        $index,
                        'selectedFilterGroup'
                      )
                    "
                  />
                </pm-form-field>

                <!-- filter option -->
                <pm-form-field
                  class="block"
                  label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET"
                >
                  <pm-form-input-select
                    [data]="
                      getFilterOptionsOfFilterGroupPlanningAccuracy($index)
                    "
                    [preserveOrder]="true"
                    [ngModel]="widget.selectedFilterOption"
                    (ngModelChange)="
                      changeDefaultFilterSelectionOfPlanningAccuracyWidget(
                        $event,
                        $index,
                        'selectedFilterOption'
                      )
                    "
                  />
                </pm-form-field>

                <!-- additional time series-->
                <pm-form-field
                  class="block"
                  label="CONFIGURATION.FORM.DATASOURCE.ADDITIONAL_TIME_SERIES_NAMES"
                >
                  <pm-form-input-select
                    [data]="additionalTimeSeriesOptions()"
                    [preserveOrder]="true"
                    [disabled]="additionalTimeSeries.length === 0"
                    [ngModel]="widget.additionalTimeSeriesName"
                    (ngModelChange)="
                      changeDefaultFilterSelectionOfPlanningAccuracyWidget(
                        $event,
                        $index,
                        'additionalTimeSeriesName'
                      )
                    "
                  />
                </pm-form-field>
              </div>
            }
            @case (WidgetType.ABC_XYZ_ANALYSIS) {
              <!-- abc xyz analysis target-->
              <div class="flex flex-col gap-4">
                @if (configuration(); as configuration) {
                  <!-- ABC Limits -->
                  <pm-form-field
                    class="block"
                    label="RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.ABC_LIMITS"
                    [pmTooltip]="'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.ABC_LIMITS_TOOLTIP'"
                  >
                    <pm-form-input-text
                      placeholder="0.8,0.95"
                      [ngModel]="widget.volumeBinLimits"
                      (ngModelChange)="
                        setBinLimitsOfAbcXyzAnalysisWidget(
                          $event,
                          $index,
                          'volumeBinLimits'
                        )
                      "
                    />
                  </pm-form-field>

                  <!-- XYZ Limits -->
                  <pm-form-field
                    class="block"
                    label="RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.XYZ_LIMITS"
                    [pmTooltip]="'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.XYZ_LIMITS_TOOLTIP'"
                  >
                    <pm-form-input-text
                      placeholder="0.8,0.95"
                      [ngModel]="widget.forecastAccuracyBinLimits"
                      (ngModelChange)="
                        setBinLimitsOfAbcXyzAnalysisWidget(
                          $event,
                          $index,
                          'forecastAccuracyBinLimits'
                        )
                      "
                    />
                  </pm-form-field>

                  <!-- Grouping -->
                  <pm-form-field
                    class="block"
                    label="RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.GROUPING"
                  >
                    <pm-form-input-select
                      [multiSelect]="true"
                      [allowUnselect]="true"
                      [data]="startForecastConfigGroupColumnOptions()"
                      [preserveOrder]="true"
                      [disabled]="
                        configuration.startForecastConfig.group_columns
                          ?.length === 0
                      "
                      [ngModel]="widget.groups"
                      (ngModelChange)="
                        changeDefaultFilterSelectionOfAbcXyzWidget(
                          $event,
                          $index,
                          'groups'
                        )
                      "
                    />
                  </pm-form-field>
                }
                <!-- planning period -->
                <pm-form-field
                  class="block"
                  label="RESULT.INSIGHTS.WIDGETS.PLANNING_ACCURACY.PLANNING_PERIOD"
                >
                  <pm-form-input-number
                    placeholder="1"
                    [min]="1"
                    [(ngModel)]="widget.planningPeriod"
                    (ngModelChange)="setPlanningPeriod($event, $index)"
                  />
                </pm-form-field>

                <!-- error measure -->
                <pm-form-field
                  class="block"
                  label="RESULT.KPIS.TITLE_BAR.ERROR_MEASURE_LABEL"
                >
                  <pm-form-input-select
                    [data]="relativeErrorMeasureOptions"
                    [preserveOrder]="true"
                    [ngModel]="widget.errorMeasure"
                    (ngModelChange)="
                      changeDefaultFilterSelectionOfAbcXyzWidget(
                        $event,
                        $index,
                        'errorMeasure'
                      )
                    "
                  />
                </pm-form-field>

                <!-- Limit time period + info tooltip -->
                <pm-form-field
                  class="block"
                  [label]="
                    ('RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.LIMIT_TIME_PERIOD'
                      | translate) +
                    ' (' +
                    ('RESULT_OVERVIEW.HORIZON.MONTHS' | translate) +
                    ')'
                  "
                  [pmTooltip]="'RESULT.INSIGHTS.WIDGETS.ABC_XYZ_ANALYSIS.LIMIT_TIME_PERIOD_TOOLTIP'"
                >
                  <pm-form-input-number
                    [ngModel]="widget.timePeriodBackwardsInMonths"
                    (ngModelChange)="
                      setTimePeriodBackwardsInMonthsForAbcXyzAnalysisWidget(
                        $event,
                        $index
                      )
                    "
                  />
                </pm-form-field>

                <!-- target unit -->
                <pm-target-unit-picker
                  [showWarningMessageForNoMultipleTargetUnit]="true"
                  [skipTargetUnitUrlUpdate]="true"
                  [targetUnit]="widget.targetUnit"
                  (targetUnitChange)="changeTargetUnit($event, $index)"
                />
              </div>
            }

            @default {
              <p class="italic text-xs">
                Keine Konfigurationsmöglichkeiten vorhanden.
              </p>
            }
          }
        </div>
        <span
          class="absolute -bottom-4 -right-4 opacity-0 group-hover:opacity-100"
        >
          <pm-button
            variant="critical"
            [icon]="trashIcon"
            [pmTooltip]="'Widget entfernen'"
            (handleClick)="removeWidget($index)"
          />
        </span>
      </div>
    }

    <div
      class="col-span-1 flex items-center justify-center h-96 bg-slate-50 border rounded"
    >
      <pm-button
        variant="subdued"
        [icon]="plusIcon"
        (handleClick)="addWidget()"
        [pmTooltip]="'Widget hinzufügen'"
      />
    </div>
  </div>
</pm-dialog>
